/**
 * Inquiry Progress Validators
 */
export default class InquiryProgressValidators {
  //---------------------------------------------------
  //
  //  API / Public Methods
  //
  //---------------------------------------------------
  static isValid(input, value) {
    switch (input.component) {
      case 'radio-matrix': {
        return this.validateMatrix(input, value);
      }
      case 'radio-matrix-advanced': {
        return this.validateMatrixAdvanced(input, value);
      }
      case 'diagnosis': {
        return this.validateDiagnosis(input, value);
      }
      default: { /* nothing do to here */ }
    }
    return this.validateDefault(input, value);
  }

  //---------------------------------------------------
  //
  //  Private Methods
  //
  //---------------------------------------------------
  /** @private */
  static validateMatrix(input, value) {
    if (value && value.constructor === Array) {
      const invalidValue = value.find(v => v.value === null || v.value === undefined);
      if (invalidValue) {
        return false;
      }
    }
    return true;
  }

  /** @private */
  static validateMatrixAdvanced(input, value) {
    if (value && value.constructor === Array) {
      const invalidValue = value.find(v => v.value === null || v.value === undefined || (v.value && v.value.length < 2));
      if (invalidValue) {
        return false;
      }
    }
    return true;
  }

  /** @private */
  static validateDiagnosis(input, value) {
    if (!value || value.constructor !== Array) {
      return false;
    }
    const regx = /\S/g;
    return value.find(v => (v.diagnosis !== null
      && v.diagnosis !== undefined
      && regx.test(v.diagnosis)
      && v.placeholder !== null
      && ['Hauptdiagnose', '1. Nebendiagnose', '2. Nebendiagnose'].includes(v.placeholder)
      && v.dms !== null) || v.diagnosis === 'KA');
  }

  /** @private */
  static validateDefault(input, value) {
    return value !== null && (
      (value.constructor === String && value !== '')
      || (value.constructor === Array && value.length !== 0)
      || (value.constructor === Number));
  }
}
